import React from "react";
import { connect } from "react-redux";
import checkJwt from './jwtChecker'
import logout from './logout'

export function requireAuthentication(Component) {
    
    return class AuthenticatedComponent extends React.Component {
        /**
         * Check if the user is authenticated, this.props.isAuthenticated
         * has to be set from your application logic (or use react-redux to retrieve it from global state).
         */

        /**
         * Render
         */

        
        render() {
            return (
                <>
                    { checkJwt()
                        ? <Component {...this.props} /> :  logout() }
                </>
            );
        }
    };
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.user.userLoggedIn,
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(requireAuthentication);
